<template>

        <!-- Modal -->
        <div class="modal fade"  :class="{ show: false, 'd-block': false }"  id="denominationModal"    aria-labelledby="denominationModalLabel" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="max-height:30%; max-width: 80%;" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="denominationModalLabel" v-if="denomination_view_type=='add'">Add Denomination</h5>
                <h5 class="modal-title" id="denominationModalLabel" v-else-if="denomination_view_type=='edit'">Edit Denomination</h5>
                <h5 class="modal-title" id="denominationModalLabel" v-else-if="denomination_view_type=='view'">View Denomination</h5>
                <button type="button" class="btn-close" :data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#denominationModal" aria-label="Close"></button>
            </div>
              <div v-if="this.denomination_view_type=='add' || this.denomination_view_type=='edit'">
              <form class="register-form" @submit.prevent="reg()">
            <div class="modal-body">

                <div class="card shadow-sm" id="stylized">
                   
                                <!-- <div class="card-body"> -->


                    <div class="card-body">
                      <h1 v-if="denomination_view_type == 'add'">Add Denomination</h1>
                      <h1 v-else-if="denomination_view_type == 'edit'">Edit Denomination</h1>
                      <br/>
                      <p></p>
        
                  <span>
                  
           




                      <div class="row">

                <div class="col">
                        <label>Denomination</label>
                        <div class="input-group">
                          

                          <input
                            type="text"
                            class="form-control"
                            :class="{ form_error: denominationErr}"
                            placeholder="Denomination"
                            @blur="denominationVal($event.target.value)" 
                            v-model.trim="formData.denomination"
                          />
                         
                        </div>
                         <div
                            :class="{ text_error: denominationErr  }"
                           v-if="denominationErr">
                          {{ denominationErr }} 
                          </div>
                      </div>







                     <div class="col">
                              <label>Is Active</label>
                            <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: is_activeErr}"
                             @change="is_activeVal($event.target.value)"
                            v-model.trim="formData.is_active">
                            <option value="">--Choose An Option--</option>
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                          </select>
                          
                          
                        </div>
                        <div
                            :class="{ text_error: is_activeErr}"
                            v-if="is_activeErr"
                          >
                            {{ is_activeErr }}
                          </div>
                      </div>

         



                     




                    </div>



                  </span>
                    </div>



                    

                                </div>
                
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" v-if="denomination_view_type=='add'">Submit</button>
                <button type="submit" class="btn btn-primary" v-if="denomination_view_type=='edit'">Update</button>
                <button type="button" class="btn btn-danger" @click="remove_all" v-if="denomination_view_type=='add'">Clear All</button>
                <button type="button" class="btn btn-secondary" ref="denomination_modal_ref" data-bs-dismiss="modal" v-if="denomination_view_type=='edit'">Close</button>
            </div>

                  </form>
                  </div>


                 <div v-else>
                      <div class="modal-body">
                        <div class="table-responsive table-responsive-data2">
                        <table class="table table-hover table-striped">
                          
                              <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Value</th>
                                </tr>
                                </thead>


                                <tbody>
                                <tr>
                                <td>Denomination</td>
                                <td>{{formData.denomination}}</td>
                                </tr>

                               <tr>
                                <td>Is Active</td>
                                <td>{{formData.is_active}}</td>
                                </tr>




                 
                              </tbody>
                                  </table>









                                                                

                    
                        </div>

                      </div>

                 </div>


            </div>
        </div>


        
        </div>
</template>

<script>
 import axios from 'axios';
import FieldValidateService from "@/services/FieldValidateService";
import notificationBox from "@/services/notificationBox";
//import SpinnerComp from "@/components/SpinnerComp.vue";
import { mapActions, mapMutations, mapState } from 'vuex';
import { DEPENDENT_LINK_REG, EDIT_DEPENDENT_LINK_REG, LOADING, RESET_DEPENDENT_SEARCH_RESULT, SEARCH_DEPENDENT } from '@/store/storeconstants';
//import VueMultiselect from 'vue-multiselect'
//import Select2 from 'vue3-select2-component';
//import vSelect from 'vue-select'

    export default {

        name:'DenominationModal',
        props:{
            denomination_view_type:{
                required:true,
            },

            denomination_data:{
                required:true,
            }
        },


           mounted(){

              // const input = document.querySelector("#telephone");
              // console.log(input);
              // intlTelInput(input,{
              //   // any initialisation options go here
              //       preferredCountries: ["gh", "us", "ca"],
                
                  
              // });

             //   console.log(localStorage.getItem("token"));

           },

        async created() {

  
  
 

        },




         data: function () {
    return {
      //userModal: null,
      link_val:"",
      app_portal: "",
      loading:false,
      errorMess: "",
      succMess:"",
      clear_user: true,
      clear_all: true,
      errorClient:[],
      errorServers:[],
       modal:"modal",


   
      

      formData: {
        portal:"",
        denomination_id:"",

        denomination: "",
        is_active: "",
        view_type:"",
        user_id:1,
        
        
      },



    //Errors  
      denominationErr: "",
      is_activeErr: "",




      // bindProps:{
      //   preferredCountries: ["GH", "US","CA","GB","NG"],
      //   name: "telephone",
      //     mode: "international",
      //     defaultCountry: "GH",
      //      dropdownOptions: {
      //     showSearchBox: true,
      //     showFlags:true,
      //   },
      // }



    };
  },


      methods: {

          ...mapActions({
            search_dependent: 'dependent/'+SEARCH_DEPENDENT,
            link_dependent_support: 'dependent/'+DEPENDENT_LINK_REG,
            edit_link_dependent_support:'dependent/'+EDIT_DEPENDENT_LINK_REG
          }),




         ...mapMutations({
                 reset_dependent_search_result: 'dependent/'+RESET_DEPENDENT_SEARCH_RESULT,
                 showLoading:LOADING,
         }),







       async reg(){
      
      //notificationBox.successAlert("Registration Successful","An Email Has Been Sent To You. Please Click On The Link To Verify Your Account") 
       //console.log(this.formData);
       // console.log(this.errorClient);
        this.errorServers = [];
       this.errorClient = [];
       this.showLoading(true);

        // this.denominationVal(this.formData.denomination);
        // this.is_activeVal(this.formData.is_active);


   

             if(this.errorClient.length > 0)
       {
         this.showLoading(false);
          notificationBox.errorNotifications("Some Errors Exist");
          console.log(this.errorClient);
          return true;
       }

   




    if(this.denomination_view_type=="add"){


         try{
            const response = await axios.post("denominations",this.formData);
              if(response.status == 200)
              {
                   this.showLoading(false);

                     this.clearFormData();
        notificationBox.succNotifications("Denomination Added Successfully");
        this.$emit("denominationAdded");
              }


         }catch(error){

                // console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);
           notificationBox.errorNotifications("Some Errors Exist");

                  if(this.errorServers.length > 0)
       {
          
            this.getServerError();
     
       }

         }
 



    }
    else if(this.denomination_view_type=="edit")
    {





         try{
            const response = await axios.patch(`denominations/${this.formData.denomination_id}`,this.formData);
              if(response.status == 200)
              {

                     this.showLoading(false);
                     this.$refs.denomination_modal_ref.click();
                     this.clearFormData();
        notificationBox.succNotifications("Denomination Added Successfully");
        this.$emit("denominationAdded");
              }


         }catch(error){

               //  console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);
           notificationBox.errorNotifications("Some Errors Exist");

                  if(this.errorServers.length > 0)
       {
          
            this.getServerError();
     
       }

         }
     

           


    }




    
    },





     clearFormData(){
        this.errorServers = [];
        this.errorClient = [];
      //this.clear_user = false;
      this.formData.denomination = "";
      this.formData.denomination_id = "";
      this.formData.is_active = "";
      this.denominationErr = "";
      this.is_activeErr = "";

    },




   getServerError(){

       this.denominationErr = 'denomination' in this.errorServers[0] ? this.errorServers[0].denomination[0] : '';
      this.is_activeErr = 'is_active' in this.errorServers[0] ? this.errorServers[0].is_active[0] : '';


     
           return true;

   },





     denominationVal(value){

      let max = 500;
      let field = "Denomination"

         if(FieldValidateService.reqMaxStringVal(value, field,max))
     {
       this.denominationErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.denominationErr);
     }else{

           this.denominationErr =""; 
          this.errorClient.pop(this.denominationErr);

     }


    },







     is_activeVal(value) {

      let max = 10;
      let field = "Is Active";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.is_activeErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.is_activeErr);
     }else{

           if(this.errorClient.includes(this.is_activeErr))
           {
            let pos = this.errorClient.indexOf(this.is_activeErr);
           this.errorClient.splice(pos,1);
            this.is_activeErr =""; 
           }
          
          

     }
    },







    




      





  

      },

      
  computed:{


    ...mapState('dependent',['dependent_view_type','dependent_info','search_message','search_dependent_result']),
    ...mapState('dependent_support',['dependent_support_view_type','dependent_support_info']),

    // firstName(){
    //   return this.checked_user_data.fullname;
    // }
  },  

    components: {
      //SpinnerComp,
      //vSelect
      //VueMultiselect
     // Select2
    },

    watch:{

 


   




        denomination_view_type(value){
          
           if(value == "add"){
        
           this.clearFormData();


           }
        },

        denomination_data(value){
       
         let data = value;
             this.clearFormData();
            //console.log(data);
            this.formData.denomination_id = data.id;
            this.formData.denomination = data.denomination;
            this.formData.is_active = data.is_active;
        
       
          
          
        },


    



    }
        
    }
</script>

<style scoped>


</style>